export type SlotCode = string; // e.g. "A1", "B3", "-"

export interface DaySchedule {
  date: string;       // "4/1" 形式
  dayOfWeek: string;  // "月"〜"金"
  // slots = [1限, 2限, 3限, 4限, 5限, 6限] の6コマ
  // 給食（○）は列としてあるが slots には含めない
  // "-" = 授業なし/空き
  slots: SlotCode[];
  note?: string;
  isHoliday?: boolean;
}

// A=月曜, B=火曜, C=水曜, D=木曜, E=金曜
// 数字=時限（1〜6）

export const aprilSchedule: DaySchedule[] = [
  // 4/1〜4/6 春休み
  { date: "4/1",  dayOfWeek: "火", slots: [], isHoliday: true },
  { date: "4/2",  dayOfWeek: "水", slots: [], isHoliday: true },
  { date: "4/3",  dayOfWeek: "木", slots: [], isHoliday: true },
  { date: "4/4",  dayOfWeek: "金", slots: [], isHoliday: true },
  { date: "4/5",  dayOfWeek: "土", slots: [], isHoliday: true },
  { date: "4/6",  dayOfWeek: "日", slots: [], isHoliday: true },

  // 4/7 火：着任式・始業式（全学年共通）、2限=3分割→3年は「学活」、3〜4=×（3年は斜線）、5=入学式、6=学活
  { date: "4/7",  dayOfWeek: "火", slots: ["着任式・始業式", "学活", "-", "-", "入学式", "学活"] },

  // 4/8 水：1=対面式（全学年共通）、2〜4=3分割→3年は「学活・学活・学活」、5=オリ（3分割→3年は「オリ」）、6=×
  { date: "4/8",  dayOfWeek: "水", slots: ["対面式", "学活", "学活", "学活", "オリ", "-"] },

  // 4/9 木：3分割→3年は「学活・身体・視力・鼻喉」、5=遠泳、6=道徳
  { date: "4/9",  dayOfWeek: "木", slots: ["学活", "身体測定", "視力", "鼻喉", "遠泳", "道徳"] },

  // 4/10 金：金1・金2・金3・金4・○・金5・学活
  { date: "4/10", dayOfWeek: "金", slots: ["E1", "E2", "E3", "E4", "E5", "学活"] },

  { date: "4/11", dayOfWeek: "土", slots: [], isHoliday: true },
  { date: "4/12", dayOfWeek: "日", slots: [], isHoliday: true },

  // 4/13 月：月2・月3・月4・月5・○・月6・全校集会
  { date: "4/13", dayOfWeek: "月", slots: ["A2", "A3", "A4", "A5", "A6", "全校集会"] },

  // 4/14 火：火1・火2・火3・火4・○・火5・6組総合/総合
  { date: "4/14", dayOfWeek: "火", slots: ["B1", "B2", "B3", "B4", "B5", "B6"] },

  // 4/15 水：水1・水2・水3・水4・○・水5
  { date: "4/15", dayOfWeek: "水", slots: ["C1", "C2", "C3", "C4", "C5", "-"] },

  // 4/16 木：木1・木2・木3・木4・○・木5・学活
  { date: "4/16", dayOfWeek: "木", slots: ["D1", "D2", "D3", "D4", "D5", "学活"] },

  // 4/17 金：金1・金2・金3・金4・○・道徳
  { date: "4/17", dayOfWeek: "金", slots: ["E1", "E2", "E3", "E4", "道徳", "-"] },

  { date: "4/18", dayOfWeek: "土", slots: [], isHoliday: true },
  { date: "4/19", dayOfWeek: "日", slots: [], isHoliday: true },

  // 4/20 月：月2・月3・月4・月5・○・学活
  { date: "4/20", dayOfWeek: "月", slots: ["A2", "A3", "A4", "A5", "学活", "-"] },

  // 4/21 火：火1・火2・火3・火4・○・火6総合/総合
  { date: "4/21", dayOfWeek: "火", slots: ["B1", "B2", "B3", "B4", "B6", "-"] },

  // 4/22 水：水1・水2・水3・水4・○・水5
  { date: "4/22", dayOfWeek: "水", slots: ["C1", "C2", "C3", "C4", "C5", "-"] },

  // 4/23 木：国語・数学・英語・英語・○・学活
  { date: "4/23", dayOfWeek: "木", slots: ["国語", "数学", "英語", "英語", "学活", "-"] },

  // 4/24 金：金2・金3・金4・金5・○・防災訓練・地区別集会
  { date: "4/24", dayOfWeek: "金", slots: ["E2", "E3", "E4", "E5", "防災訓練", "地区別集会"] },

  { date: "4/25", dayOfWeek: "土", slots: [], isHoliday: true },
  { date: "4/26", dayOfWeek: "日", slots: [], isHoliday: true },

  // 4/27 月：月3・月4・月5・○・月6・遠泳
  { date: "4/27", dayOfWeek: "月", slots: ["A3", "A4", "A5", "A6", "遠泳", "-"] },

  // 4/28 火：火1・火2・火3・火4・○・火5
  { date: "4/28", dayOfWeek: "火", slots: ["B1", "B2", "B3", "B4", "B5", "-"] },

  // 4/29 水：昭和の日
  { date: "4/29", dayOfWeek: "水", slots: [], isHoliday: true, note: "昭和の日" },

  // 4/30 木：木1・木2・木3・木5・○・学活
  { date: "4/30", dayOfWeek: "木", slots: ["D1", "D2", "D3", "D5", "学活", "-"] },
];
